module.exports = __webpack_public_path__ + "static/media/13.metallicSilver.bdd4262e.png";